<template>
  <app-content>
    <h1>Contact</h1>
    <div class="contact-wrapper">
      <div class="contact-message">
        お気軽にご連絡ください。<br />
        Twitterでも連絡は取れますが、メールで連絡していただいた方が返信が早くなると思います。<br />
        2,3日経って返信がない場合は見逃している可能性がありますので、お手数ですがもう一度送信して頂くようご協力お願いいたします。
      </div>
      <div class="contact-items">
        <div class="contact-item" v-for="contact in contacts" :key="contact.kind">
          <a class="contact-link" :href="contact.url" target="_blank">
            <img :src="contact.image" :alt="contact.kind" />
            <span>{{ contact.name }}</span>
          </a>
        </div>
        <div class="contact-item">
          <a class="contact-link" :href="`mailto:${mail.address}`">
            <img :src="mail.image" alt="Mail" />
            <span>Mail</span>
          </a>
        </div>
      </div>
    </div>
  </app-content>
</template>

<script>
import AppContent from 'src/components/AppContent'
import data from './data'

export default {
  data: () => {
    return {
      ...data
    }
  },
  components: {
    AppContent
  }
}
</script>

<style scoped>
.contact-wrapper {
  display: flex;
  flex-direction: column;
}

.contact-message {
  margin-bottom: 24px;
  text-align: justify;
  text-justify: inter-ideograph;
}

.contact-items {
  display: flex;
  flex-direction: column;
}

.contact-link {
  display: flex;
  width: fit-content;
  margin: 16px 0;
  font-size: 24px;
  vertical-align: middle;
  text-decoration: none;
}

.contact-link img {
  width: 32px;
  height: 32px;
  margin-right: 16px;
}

.contact-link span {
  text-decoration: underline;
}
</style>
